export default function bundleSelect($stateParams, $state, $rootScope, API, UserCache) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      tags: '=tags',
      multiple: '=multiple',
      type: '=type',
    },
    template: '<input type="hidden" class="bigdrop" id="e8" style="width:400px;"/>',
    link: selectLink,
  }

  return directive

  function selectLink($scope, $element, $attr) {
    var auth = UserCache.getObject()
    $.ajaxSetup({
      headers: {
        'X-Collectible-Platform': 'QP2',
        Authorization: 'Bearer ' + auth.jwt,
      },
    })
    $('#e8').select2({
      ajax: {
        url: function (t, page) {
          var start, limit
          if (page === 1) {
            start = 0
            limit = 25
          } else {
            limit = page * 25
            start = limit - 25
          }
          return API.API_URL + 'admin/bundles?start=' + start + '&limit=' + limit
        },
        dataType: 'json',
        quietMillis: 250,
        data: function (t, page) {
          if ($rootScope.bundleType === 'channel') {
            return {
              page: page,
              chId: t,
            }
          } else if ($rootScope.bundleType === 'set') {
            return {
              page: page,
              sId: t,
            }
          } else if ($rootScope.bundleType === 'bundle') {
            return {
              page: page,
              bId: t,
            }
          } else if ($rootScope.bundleType === 'bundle_title') {
            return {
              page: page,
              t: t,
            }
          } else {
            if ($scope.type) {
              return {
                page: page,
                t: t,
                sTi: t,
                chTi: t,
                ty: $scope.type,
              }
            }
            return {
              page: page,
              t: t,
              sTi: t,
              chTi: t,
            }
          }
        },
        results: function (data, page) {
          $rootScope.$broadcast('bundleList', data.results)
          return {
            results: data.results,
            more: page + 25 < data.ct,
          }
        },
      },
      multiple: $scope.multiple,
      escapeMarkup: function (markup) {
        return markup
      }, // let our custom formatter work
      minimumInputLength: 1,
      formatResult: formatState,
      formatSelection: formatStateSelection,
    })

    function formatState(state) {
      if (state.loading) {
        return state.text
      }

      var statusType = function (st) {
        switch (st) {
          case 0:
            return 'Draft'
          case 1:
            return 'Published'
          case 2:
            return 'Sold Out'
          case 3:
            return 'Sold Out For User'
          case 4:
            return 'Archived'
          case 5:
            return 'Hidden From User'
          case 6:
            return 'Unavailable For User'
          case 7:
            return 'Unavailable'
          case 8:
            return 'In Progress For User'
          case 9:
            return 'Other In Progress For User'
          case 10:
            return 'Awaiting Collectible Count'
          default:
            break
        }
      }

      var ch = null
      var set = null
      if (state.s && state.s.ch) {
        ch = state.s.ch.t
      } else if (state.ch) {
        ch = state.ch.t
      } else {
        ch = '-'
      }

      if (state.s) {
        set = state.s.t
      } else {
        set = '-'
      }

      var markup =
        "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>ID: " +
        state.id +
        '</div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Channel: " +
        ch +
        '</div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Set: " +
        set +
        '</div>' +
        '<div>' +
        state.t +
        '</div>' +
        '<div>Status: ' +
        statusType(state.st) +
        '</div>' +
        '</div>' +
        '</div></div>'

      return markup
    }

    function formatStateSelection(state) {
      return state.t
    }
  }
}
